<template>
    <div class="my-checkbox">
        <div
            v-for="(result, index) in options" 
            :key="index"
            class="form-check form-check-inline"
            :class="value && value.toString().split(',').includes((multiple == true) ? result.id.toString() : '1') ? 'checked' : ''"
        >
            <input
                :ref="(multiple == true) ? 'checkbox_' + index : 'chechbox'"
                type="checkbox"
                class="form-check-input"
                v-model="current_value"
                :name="(multiple == true) ? name + '[]' : result.id"
                :id="(multiple == true) ? name + '_' + index : result.id"
                :value="(multiple == true) ? result.id : 1"
                @input="onInput"
            />
            <label
                class="form-check-label"
                :for="(multiple == true) ? name + '_' + index : result.id">
                <template v-if="!result.name.img">
                    {{ result.name | capitalize }}
                </template>
                <template v-else>
                    {{ result.name.text | capitalize }}
                    <masked-image :src="result.name.img"></masked-image>
                </template>
            </label>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        label: {
            type: String,
            required: false,
        },

        multiple: {
            type: Boolean,
            required: false,
        },

        name: {
            type: String,
            required: false,
        },

        options: {
            type: Array | Object,
            required: true,
        },

        value: {
            type: String | Number,
            required: false,
        },
    },

    data() {
        return {
            current_label: this.label,
            current_value: this.value ? this.value.toString().split(',') : [],
            checked: []
        }
    },

    mounted() {
        // console.log(this.name)
    },

    methods: {
        onInput(event) {
            let value = this.current_value ?? []
            if (event.target.checked == true) {
                value.push(event.target.value)
            } else {
                value.remove(event.target.value)
            }

            this.$emit('input', value.join(','))
        },

        clearInput() {
            this.current_value = (this.multiple == true) ? [] : null

            this.$emit('input', '')
        },
    },

    
}
</script>